import {getAuthenticatedThemisClient, CompanyPatchRequestView} from '@modifi/onboarding-api-clients'
import {Reducer, updateFactory} from '@modifi/redux'
import {aFetchCompany, aUpdateLocalOnboardingCompany} from './entity'
import {NestedError} from '../../utils'

const apiClient = getAuthenticatedThemisClient()

const {actions, reducer} = updateFactory({
  rootSelector: state => state?.data?.company?.update,
  actionNamePrefix: 'data/company/update',
  submitRequest:
    (a, changes: CompanyPatchRequestView) =>
    async (dispatch): Promise<void> => {
      try {
        if (Object.keys(changes).length > 0) {
          dispatch(a.pendingAction())
          const updatedCompany = await apiClient.Company.update({
            body: changes,
          }).then(res => res.data())
          dispatch(aUpdateLocalOnboardingCompany(updatedCompany, false))

          dispatch(a.successAction())
        }
      } catch (e: any) {
        dispatch(a.errorAction(e))
        throw new NestedError(`Error while calling Company.update endpoint`, e)
      } finally {
        await dispatch(aFetchCompany())
      }
    },
})

export default reducer as Reducer

export const {aSubmit: aUpdateCompany} = actions
